type ProgressTone = 'primary' | 'accent' | 'secondary';

const toneClasses: Record<ProgressTone, string> = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-500',
};

interface ProgressBarProps {
  value: number;
  tone?: ProgressTone;
  showLabel?: boolean;
  className?: string;
}

export default function ProgressBar({
  value,
  tone = 'primary',
  showLabel = false,
  className = '',
}: ProgressBarProps) {
  const safe = Math.max(0, Math.min(100, value));
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-200">
        <div
          className={`h-full rounded-full animate-grow-x transition-[width] duration-700 ${toneClasses[tone]}`}
          style={{ width: `${safe}%` }}
        />
      </div>
      {showLabel ? (
        <span className="text-xs font-label text-foreground-600">{safe}%</span>
      ) : null}
    </div>
  );
}